<section class="community-section">

    <div class="container">

        <div class="text-center mb-5">

            <span class="badge bg-primary  mb-4">
                Why Join SoniBiz
            </span>

            <h2 class="display-5 fw-bold">
                Unlock the Power of the
                <span class="text-primary">Soni Network</span>
            </h2>

            <p class="lead text-secondary mx-auto" style="max-width:700px;">
                SoniBiz helps professionals, entrepreneurs, and business owners
                connect, collaborate, and create meaningful opportunities within a trusted community.
            </p>

        </div>

        <div class="row g-4">

            <div class="col-lg-3 col-md-6">

                <div class="benefit-card h-100">

                    <div class="benefit-icon">
                        <i class="fas fa-handshake"></i>
                    </div>

                    <h5>Trusted Connections</h5>

                    <p>
                        Build relationships with verified professionals,
                        entrepreneurs and business owners.
                    </p>

                </div>

            </div>

            <div class="col-lg-3 col-md-6">

                <div class="benefit-card h-100">

                    <div class="benefit-icon">
                        <i class="fas fa-share-nodes"></i>
                    </div>

                    <h5>Business Referrals</h5>

                    <p>
                        Exchange quality referrals and discover new
                        business opportunities through your network.
                    </p>

                </div>

            </div>

            <div class="col-lg-3 col-md-6">

                <div class="benefit-card h-100">

                    <div class="benefit-icon">
                        <i class="fas fa-lightbulb"></i>
                    </div>

                    <h5>Mentorship & Learning</h5>

                    <p>
                        Learn from experienced members and gain
                        practical insights for growth.
                    </p>

                </div>

            </div>

            <div class="col-lg-3 col-md-6">

                <div class="benefit-card h-100">

                    <div class="benefit-icon">
                        <i class="fas fa-chart-line"></i>
                    </div>

                    <h5>Growth Opportunities</h5>

                    <p>
                        Find partnerships, collaborations,
                        investments and career opportunities.
                    </p>

                </div>

            </div>

        </div>

    </div>

</section>